import {Helper} from "@nolimitcity/promo-panel/bin/utils/Helper";
import { WINTYPE} from "@nolimitcity/promo-panel/bin/enums/ASEnums";
import {
    ActionSpinOptions,
    ActionSpinSound,
    ASWinData,
    PromoPanelGameConfiguration,
} from "@nolimitcity/promo-panel/bin/interfaces/ASInterfaces";
import {KitchenDramaSushiManiaGameMode} from "./server/KitchenDramaSushiManiaGameMode";
import {KitchenDramaSushiMania} from "./KitchenDramaSushiMania";
import {KitchenDramaSushiManiaSound} from "./sound/KitchenDramaSushiManiaSound";



export class KitchenDramaSushiManiaPromoPanelConfig implements PromoPanelGameConfiguration {

    constructor() {}

    public getActionSpinOptions():ActionSpinOptions {
        return {
            gameName:"Kitchen Drama: Sushi Mania",
            hasActionSpin:true,
            getParsedData:(response:any, bet:number, prevResponse:any):ASWinData => {
                const parsedData:ASWinData = {
                    totalWin:response.totalRoundWin,
                    totalSpinWinnings:this.getWin(response, bet, prevResponse),
                    wasFeatureBuy:response.wasFeatureBuy,
                    freeSpinTriggeredThisSpin:this.isFreeSpinTriggered(response),
                    isBigWin:this.isBigWin(response),
                    winType:WINTYPE.NORMAL,
                    featureName:this.getFeatureName(response),
                    isRoundComplete:this.isRoundComplete(response),
                    isBonusEnd:this.isBonusEnd(response),
                    isWinCapHit:false
                }
                return parsedData;
            }
        };
    }

    private isBigWin(response:any):boolean {
        const win = response.totalSpinWin;
        const playedBetValue = response.playedBetValue;
        let winRatio:number = Helper.ceilToDecimals((win / playedBetValue), 2);

        return winRatio >= 15;
    }

    private getWin(response:any, bet:number, prevData:any):number {
        return response.totalSpinWin;
    }

    private getFeatureName(response:any):string {
        if (response.mode == KitchenDramaSushiManiaGameMode.WILD_SUSHI || response.nextMode == KitchenDramaSushiManiaGameMode.WILD_SUSHI){
            return "WILD SUSHI FREE SPINS"
        }
        return "";
    }

    private isFreeSpinTriggered(response:any):boolean {
        return response.freespinTriggeredThisSpin;

    }

    private isRoundComplete(response:any):boolean {
        return ([KitchenDramaSushiManiaGameMode.NORMAL, KitchenDramaSushiManiaGameMode.WILD_SUSHI].indexOf(response.nextMode) > -1);
    }

    private isBonusEnd(response:any):boolean {
        return response.nextMode === KitchenDramaSushiManiaGameMode.NORMAL && (response.mode.indexOf("WILD_SUSHI") === -1);
    }


    public onActionSpinPlaySound(trigger:ActionSpinSound):void {
        if (trigger == ActionSpinSound.WIN) {
            KitchenDramaSushiMania.soundPlayer.playSound(KitchenDramaSushiManiaSound.AS_WIN);
        } else if (trigger == ActionSpinSound.BIG_WIN) {
            KitchenDramaSushiMania.soundPlayer.playSound(KitchenDramaSushiManiaSound.AS_WIN_BIG);
        }
    }

}